import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Observer } from 'gsap/Observer'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  init() {
    this.image = this.el.querySelector('[data-module-image]')
    this.wrapper = this.el.querySelector('[data-project-wrapper ]')

    this.transition()
    this.cursor()
    this.tooltip()
  }

  tooltip() {
    const info = this.el.querySelector('[data-project-info]')
    const infoTimeline = gsap.timeline({ paused: true })

    infoTimeline.fromTo(
      info,
      {
        opacity: 0,
        y: 10,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.25,
      },
    )

    this.image.addEventListener('click', () => {
      if (!this.state) {
        infoTimeline.play()
      } else {
        infoTimeline.reverse()
      }
      info.classList.toggle('pointer-events-none', this.state)
      this.state = !this.state
    })
  }

  cursor() {
    this.state = false
    const cursor = document.querySelector('#cursor')
    const xTo = gsap.quickSetter(cursor, 'x', 'px')
    const yTo = gsap.quickSetter(cursor, 'y', 'px')

    Observer.create({
      target: window,
      type: 'pointer',
      onMove: ({ x, y }) => {
        xTo(x)
        yTo(y)
      },
    })

    const button = cursor.querySelector('[data-cursor-button]')
    const text = cursor.querySelector('[data-cursor-text]')
    gsap.set([button, text], { opacity: 0 })

    if (!window.cursorTimeline) {
      window.cursorTimeline = gsap.timeline({ paused: true })
      window.cursorTimeline.fromTo(
        button,
        {
          opacity: 0,
          scale: 0,
          duration: 0.15,
          ease: 'power3.out',
        },
        {
          opacity: 1,
          scale: 1,
          duration: 0.15,
          ease: 'power3.out',
        },
      )
      window.cursorTimeline.to(
        text,
        {
          opacity: 1,
          duration: 0.25,
        },
        '<0.25',
      )
    }

    this.image.addEventListener('mouseenter', () => {
      if (this.state) return
      document.documentElement.classList.add('no-cursor')
      window.cursorTimeline.timeScale(1).play()
    })
    this.image.addEventListener('mouseleave', () => {
      if (this.state) return
      document.documentElement.classList.remove('no-cursor')
      window.cursorTimeline.timeScale(2).reverse()
    })
  }

  transition() {
    const mm = gsap.matchMedia()

    mm.add('(min-width: 1024px)', () => {
      const nestedImg = this.image.querySelector('img')

      gsap.set(nestedImg, { scale: 1.05 })
      const tl = gsap.timeline({})
      tl.from(this.image, {
        rotateZ: 2.5,
        ease: 'power2.out',
        duration: 1,
      })
      tl.to(
        nestedImg,
        {
          scale: 1,
          ease: 'power3.out',
          duration: 1,
        },
        0,
      )
      tl.to(this.el, { scale: 1, duration: 1 })
      tl.to(
        this.image,
        {
          // rotateZ: -5,
          y: -60,
          scale: 0.9,
          duration: 1,
          ease: 'power1.in',
        },
        '<0.5',
      )

      ScrollTrigger.create({
        trigger: this.el,
        animation: tl,
        start: '25% bottom',
        end: 'bottom bottom',
        scrub: 2,
      })
    })
  }
}
